if (!window.DigitalizModules) window.DigitalizModules = {};

if (!window.DigitalizModules.ProductsSlider) {
  class ProductsSlider {
    constructor(root) {
      this.root = root;
      this.splide = null;
      this._init();
    }

    _init() {
      if (typeof window.Splide !== 'function') return;

      const sliderEl = this.root.querySelector('[data-psl-slider]');
      if (!sliderEl) return;

      const showDots = sliderEl.dataset.pslPagination === 'true';
      const loopMode = sliderEl.dataset.pslLoopMode || 'loop';
      const autoplay = sliderEl.dataset.pslAutoplay === 'true';
      const interval = parseInt(sliderEl.dataset.pslAutoplayInterval, 10) || 4000;
      const pauseOnHover = sliderEl.dataset.pslPauseOnHover === 'true';
      const speed = parseInt(sliderEl.dataset.pslSpeed, 10) || 600;

      const options = {
        perPage: 2,
        gap: '1.6rem',
        pagination: showDots,
        arrows: false,
        speed: speed,
        breakpoints: {
          1200: {
            gap: '1rem',
          },
          // Mobile: prev/next arrows (markup in the section) replace the dots.
          768: {
            perPage: 1,
            gap: '0.8rem',
            arrows: true,
            pagination: false,
          },
        },
      };

      if (loopMode === 'loop') {
        options.type = 'loop';
      } else if (loopMode === 'rewind') {
        options.rewind = true;
      }

      if (autoplay) {
        options.autoplay = true;
        options.interval = interval;
        options.pauseOnHover = pauseOnHover;
      }

      this.splide = new window.Splide(sliderEl, options).mount();

      this._preloadImages();
    }

    _preloadImages() {
      const doPreload = () => {
        this.root.querySelectorAll('.splide__slide img[data-pc-image]').forEach(img => {
          const src = img.getAttribute('src');
          if (!src || img.dataset.preloaded) return;
          img.dataset.preloaded = '1';
          const p = new Image();
          p.src = src;
        });
      };

      if (document.readyState === 'complete') {
        doPreload();
      } else {
        window.addEventListener('load', doPreload, { once: true });
      }
    }

    destroy() {
      if (this.splide) {
        this.splide.destroy();
        this.splide = null;
      }
    }
  }

  window.DigitalizModules.ProductsSlider = ProductsSlider;

  function initSliders(root) {
    root.querySelectorAll('[data-products-slider]').forEach(el => new ProductsSlider(el));
  }

  initSliders(document);

  // Re-init when the Theme Editor adds or re-renders a section
  document.addEventListener('shopify:section:load', (event) => {
    initSliders(event.target);
    if (event.target.matches('[data-products-slider]')) new ProductsSlider(event.target);
  });
}
